/**
 *
 * ModalUnitSwitchInfo
 *
 */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { DhlText, DhlButton } from "@dhl-official/react-library";
import { Variants } from "@dhl-official/stencil-library";
import { injectIntl } from "react-intl";
import styled from "styled-components";
import { ContentModal, Headline } from "root/libs/ui-components/src";

const Content = styled.div`
  [type="button"] {
    margin-right: 10px;
  }
`;

const CopyText = styled(DhlText)`
  display: block;
  & > *:is(p, span) {
    margin-bottom: 20px;
    margin-top: 10px;
  }
`;

const COPY_ID_PREFIX = "ModalUnitSwitchInfo";

const ModalUnitSwitchInfo = (props) => {
  const { intl, onClose, unitSystem, newUnitValue, trackEvent } = props;

  useEffect(() => {
    trackEvent({ unitSelectorWarningModalTriggered: true });
  }, []);

  const onConfirmationClick = () => {
    trackEvent({ clickedOnProceedUnitSelectionChange: true });
    onClose(true);
  };

  const onCancellationClick = () => {
    trackEvent({ clickedOnCancelUnitSelectionChange: true });
    onClose(false);
  };

  const getCopy = (id, values, prefix = COPY_ID_PREFIX) => {
    return intl.formatMessage({ id: `${prefix}.${id}` }, values);
  };

  return (
    <ContentModal
      {...props}
      closeButtonAriaLabel={intl.formatMessage({ id: "SS.ContentModal.close" })}
      contentAriaLabel={getCopy("headline")}
      smallCenteredModal
    >
      <Content data-testid="modal-unit-switch-info">
        <Headline priority={2}>{getCopy("headline")}</Headline>
        <CopyText isParagraph>
          {getCopy("description1")}
          <strong>{`${unitSystem[newUnitValue].weight}/${unitSystem[newUnitValue].length}`}</strong>
          {getCopy("description2")}
        </CopyText>
        <DhlButton type="button" clickEvent={onConfirmationClick}>
          {getCopy("primaryCTA")}
        </DhlButton>
        <DhlButton
          type="button"
          variant={Variants.outline}
          clickEvent={onCancellationClick}
        >
          {getCopy("secondaryCTA")}
        </DhlButton>
      </Content>
    </ContentModal>
  );
};

ModalUnitSwitchInfo.propTypes = {
  intl: PropTypes.any.isRequired,
  onClose: PropTypes.func,
  unitSystem: PropTypes.object.isRequired,
  newUnitValue: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

ModalUnitSwitchInfo.defaultProps = {
  onClose: () => {},
};

export default injectIntl(ModalUnitSwitchInfo);
